export const EDITOR_WIDTH_LIMIT = {
  MIN: 1,
  MAX: 1000
};

export const EMAIL_EDITOR_SIZE_LIMIT = 25_000; // 25kB
